module.exports = __webpack_public_path__ + "static/playhero-76d029574f74152e46650385d0eecff9.png";